import { orchestrator } from 'satcheljs';
import { loadActivityFeed } from '../actions/loadActivityFeed';
import { activityFeedLoaded } from '../actions/activityFeedLoaded';
import { getActivityFeed } from '../service/getActivityFeed';
import { getActivityFeedStore } from '../store/store';
import { activityFeedItemsSeen } from '../actions/activityFeedItemsSeen';

orchestrator(loadActivityFeed, async () => {
    const feed = await getActivityFeed();
    activityFeedLoaded(feed);
    if (getActivityFeedStore().isActivityFeedOpen === true) {
        const items = [...getActivityFeedStore().items.values()];
        activityFeedItemsSeen(items.filter(item => !item.isSeen).map(item => item.id));
    }
});
